import { render, staticRenderFns } from "./available-disbursement.vue?vue&type=template&id=1374126f&"
import script from "./available-disbursement.vue?vue&type=script&lang=js&"
export * from "./available-disbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports